import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { View } from 'react-native';

/** A labelled row of the column editor: an input, or a row of choices. */
export const EditorField = memo(
  ({
    label,
    hint,
    children,
  }: {
    label: string;
    hint?: string;
    children: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ gap: rpx(6) }}>
        <Typography.Text size={rpx(12)} color={aiColors.mutedForeground}>
          {label}
        </Typography.Text>
        <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: rpx(6) }}>
          {children}
        </View>
        {hint ? (
          <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
            {hint}
          </Typography.Text>
        ) : null}
      </View>
    );
  },
);
